import { makeVar } from '@apollo/client'

import { FileWithId } from 'components/File'

export const rvPersistedFiles = makeVar<Record<string, FileWithId[]>>({})

export const rvUploadedFiles = makeVar<Record<string, FileWithId[]>>({})
